<template>
  <ContentPage title="Disclaimer" updated="Laatste update: mei 2025">
    <h2>Gebruik van de website</h2>
    <p>Plug2Charge B.V. streeft ernaar de informatie op deze website zo volledig en nauwkeurig mogelijk te houden. Aan de inhoud van deze website kunnen echter geen rechten worden ontleend.</p>

    <h2>Aansprakelijkheid</h2>
    <p>Plug2Charge is niet aansprakelijk voor schade die voortvloeit uit het gebruik van deze website of de op deze website aangeboden informatie, tenzij de schade het gevolg is van opzet of grove nalatigheid.</p>
    <p>Wij zijn niet verantwoordelijk voor de inhoud van websites waarnaar wordt gelinkt via hyperlinks.</p>

    <h2>Intellectueel eigendom</h2>
    <p>Alle op deze website gepubliceerde teksten, foto's en overige materialen zijn eigendom van Plug2Charge B.V. of worden gebruikt met toestemming van de rechthebbenden. Niets van deze website mag worden overgenomen, verspreid of gepubliceerd zonder voorafgaande schriftelijke toestemming.</p>

    <h2>Prijzen en beschikbaarheid</h2>
    <p>Alle genoemde prijzen zijn inclusief BTW en exclusief verzendkosten, tenzij anders vermeld. Hoewel wij er alles aan doen om prijzen en voorraad actueel te houden, kunnen hieraan geen rechten worden ontleend.</p>

    <h2>Toepasselijk recht</h2>
    <p>Op deze disclaimer en het gebruik van de website is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.</p>

    <h2>Contact</h2>
    <p>Vragen over deze disclaimer? Neem contact op via <a href="mailto:info@plug2charge.nl">info@plug2charge.nl</a>.</p>
  </ContentPage>
</template>

<script setup>
import ContentPage from '@components/ContentPage.vue'
</script>
